import React from 'react';
import { motion } from 'framer-motion';

const AnimatedProductCard = ({ children, index = 0 }) => {
    return (
        <motion.div
            initial={{
                opacity: 0,
                y: 60,
                rotateX: 15
            }}
            whileInView={{
                opacity: 1,
                y: 0,
                rotateX: 0
            }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{
                duration: 0.6,
                delay: index * 0.15,
                ease: [0.25, 0.46, 0.45, 0.94]
            }}
            whileHover={{
                scale: 1.03,  // REDUCED from 1.08 to 1.03
                y: -4,        // REDUCED from -8 to -4
                transition: {
                    duration: 0.2,  // FASTER response
                    ease: "easeOut"
                }
            }}
            style={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                cursor: 'pointer',  // ADDED: Makes it clear it's clickable
                willChange: 'transform',  // ADDED: Performance hint
            }}
        >
            <motion.div
                style={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    position: 'relative',
                    pointerEvents: 'auto',  // ADDED: Ensure clicks work
                }}
                whileHover={{
                    boxShadow: '0 12px 24px rgba(62, 109, 156, 0.2), 0 6px 12px rgba(253, 112, 20, 0.1)',
                }}
                transition={{ duration: 0.2 }}
            >
                {/* Gradient border effect on hover */}
                <motion.div
                    style={{
                        position: 'absolute',
                        top: -2,
                        left: -2,
                        right: -2,
                        bottom: -2,
                        borderRadius: '12px',
                        background: 'linear-gradient(135deg, #3E6D9C, #FD7014)',
                        opacity: 0,
                        zIndex: -1,
                        pointerEvents: 'none',  // ADDED: Don't block clicks
                    }}
                    whileHover={{ opacity: 1 }}
                    transition={{ duration: 0.2 }}
                />

                {children}
            </motion.div>
        </motion.div>
    );
};

export default AnimatedProductCard;